import React from "react";
import WorkTile from "./WorkTile";
import { workGroups } from "../../data/workIndex";

// Every piece in two titled groups, no filters: case studies and apps two
// across from 900, interfaces and motion three across from 900 and two from
// 640. One column on phones.

function WorkGrid() {
  return workGroups.map((group) => (
    <section
      key={group.id}
      className="pf-shell pf-work-group"
      aria-labelledby={`${group.id}-title`}
    >
      <div className="pf-section__head">
        <h2 id={`${group.id}-title`} className="pf-section__title">
          {group.title}
        </h2>
      </div>
      <ul className={`pf-tiles pf-tiles--${group.columns}`}>
        {group.tiles.map((tile) => (
          <li key={tile.id}>
            <WorkTile tile={tile} />
          </li>
        ))}
      </ul>
    </section>
  ));
}

export default WorkGrid;
